/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceConnectionStatusDto } from "./DeviceConnectionStatusDto";
import {
    DeviceConnectionStatusDtoFromJSON,
    DeviceConnectionStatusDtoFromJSONTyped,
    DeviceConnectionStatusDtoToJSON,
} from "./DeviceConnectionStatusDto";

/**
 *
 * @export
 * @interface DeviceConnectionStatusResponse
 */
export interface DeviceConnectionStatusResponse {
    /**
     *
     * @type {Array<DeviceConnectionStatusDto>}
     * @memberof DeviceConnectionStatusResponse
     */
    deviceConnectionStatuses: Array<DeviceConnectionStatusDto>;
}

/**
 * Check if a given object implements the DeviceConnectionStatusResponse interface.
 */
export function instanceOfDeviceConnectionStatusResponse(
    value: object,
): value is DeviceConnectionStatusResponse {
    if (
        !("deviceConnectionStatuses" in value) ||
        value["deviceConnectionStatuses"] === undefined
    )
        return false;
    return true;
}

export function DeviceConnectionStatusResponseFromJSON(
    json: any,
): DeviceConnectionStatusResponse {
    return DeviceConnectionStatusResponseFromJSONTyped(json, false);
}

export function DeviceConnectionStatusResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceConnectionStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        deviceConnectionStatuses: (
            json["deviceConnectionStatuses"] as Array<any>
        ).map(DeviceConnectionStatusDtoFromJSON),
    };
}

export function DeviceConnectionStatusResponseToJSON(
    value?: DeviceConnectionStatusResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceConnectionStatuses: (
            value["deviceConnectionStatuses"] as Array<any>
        ).map(DeviceConnectionStatusDtoToJSON),
    };
}
